import React from 'react'
import { ItemContact } from './ItemContact'

export function ListContacts({ data, busca }) {
    if (!data) {
        return null
    }

    return data?.pages?.map((page, pageIndex) => (
        <React.Fragment key={pageIndex}>
            {page.data.map((cliente, index) => (
                <ItemContact key={index} cliente={cliente} />
            ))}
        </React.Fragment>
    ))
}
